import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-p2-import-procs',
  templateUrl: './p2-import-procs.component.html',
  styleUrls: ['./p2-import-procs.component.css']
})
export class P2ImportProcsComponent implements OnInit {
    public itemsListImportProcedures: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadImportProcedures() {
        this.itemsListImportProcedures = await this.datatask.Post(877, { show_in_excelimport: 'A' });
    }

    private async init() {
        this.loadImportProcedures();
    }

    ngOnInit() {
        this.init();
    }
}
